import ChevronDown from "@uui/ChevronDown";
import ChevronUp from "@uui/ChevronUp";

import { Row } from "@rui/Stack";

import { Container, Title, Control } from "./styles";

interface ChapterBreakProps {
  title: string;
  id: string;
  nextChapterId?: string | null;
  previousChapterId?: string | null;
  onPageUp?: (previousChapterId: string) => void;
  onPageDown?: (nextChapterId: string) => void;
}

const ChapterBreak = ({
  title,
  nextChapterId,
  previousChapterId,
  onPageDown,
  onPageUp,
}: ChapterBreakProps) => (
  <Container sx={{ pt: previousChapterId ? undefined : 2 }}>
    <Title>{title}</Title>
    <Row spacing={0.5} sx={{ pr: 1 }}>
      <Control
        disabled={!previousChapterId}
        onClick={() => previousChapterId && onPageUp?.(previousChapterId)}
        tooltip="Previous Chapter"
      >
        <ChevronUp />
      </Control>
      <Control
        disabled={!nextChapterId}
        onClick={() => nextChapterId && onPageDown?.(nextChapterId)}
        tooltip="Next Chapter"
      >
        <ChevronDown />
      </Control>
    </Row>
  </Container>
);

export default ChapterBreak;
